module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.5.0 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support prop:close-on-confirm")]), _vm._v(" "), _c('li', [_vm._v("[feature] Support prop:show-input")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime-view.html"
    }
  }, [_vm._v("DatetimeView")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/loading.html"
    }
  }, [_vm._v("Loading")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:transition")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-button.html"
    }
  }, [_vm._v("XButton")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add primary、warn disabled bg color. #1630")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-switch.html"
    }
  }, [_vm._v("XSwitch")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] we can use prop:prevent-default to prevent from setting value on being clicked #1606")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-89444bde", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-89444bde"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.5.0-111.vue
// module id = 2381
// module chunks = 291